import { imageTitle } from './ImageStore';

import { imageTitleDefault } from './ImageStoreDefaults';

export const resetImageTitle = () => {
	imageTitle.set(imageTitleDefault);
};
